import {
    Box, Button, Paper,
    Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow,
    Typography, DialogContent, DialogContentText, Dialog,
    FormControl, InputLabel, OutlinedInput, InputAdornment
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrders, confyrmOrder } from '../../store/slice/historySlice'
import { payoutData } from '../../store/slice/userSlice'
import CircularProgress from '@mui/material/CircularProgress';

const AccountMain = () => {

    const dispatch = useDispatch()
    const { data } = useSelector(state => state.history)
    const { user, isLoading } = useSelector(state => state.user)



    const [payout, setPayout] = useState(false)
    const [payoutAddress, setPayoutAddress] = useState('')
    const [payoutAmount, setPayoutAmount] = useState(0)
    const [showMes, setShowMes] = useState(false)

    const handlerConfyrm = (id) => {
        dispatch(confyrmOrder({ id }))
    }

    const handlerGetPayout = () => {
        setPayout(true)
        setPayoutAmount(parseInt(user?.payout, 10))
    }

    const handleAmountChange = (e) => {
        // убираем всё, что не число
        let value = e.target.value.replace(/\D/g, '');

        // ограничиваем по максимуму
        if (Number(value) > parseInt(user?.balance, 10)) {
            value = parseInt(user?.balance, 10).toString();
        }

        setPayoutAmount(value);
    };

    const handleAddressChange = (e) => {
        let value = e.target.value.replace(/\D/g, ''); // оставляем только цифры
        if (value.length > 16) value = value.slice(0, 16); // максимум 16 цифр

        // форматируем каждые 4 цифры
        const formattedValue = value.replace(/(\d{4})(?=\d)/g, '$1 ');

        setPayoutAddress(formattedValue);
    };

    const handlePayoutData = () => {
        dispatch(payoutData(
            {
                amount: payoutAmount,
                address: payoutAddress
            }
        )).then(() => {
            setPayoutAddress('')
            setPayoutAmount(0)
            setShowMes(true)
        })
    }

    const isFormValid =
        Number(payoutAmount) > 0 && payoutAddress.replace(/\s/g, "").length === 16;

    useEffect(() => {
        dispatch(fetchOrders())
    }, [dispatch])

    return (
        <>

            <Dialog
                open={payout}
                onClose={() => {
                    setPayoutAddress('')
                    setPayoutAmount(0)
                    setPayout(false)
                }}

            >

                <DialogContent>
                    <DialogContentText >
                        <Box
                            display="flex"
                            flexDirection="column"
                            gap={2}
                            minWidth="250px"
                        >
                            <Typography align='center' variant="h5" sx={{ mt: 2 }}>
                                Вывод средств
                            </Typography>


                            {
                                showMes ?
                                    <>
                                        <Typography align="center">
                                            На указанную вами при регистрации почту отправлен код подтверждения.
                                        </Typography>
                                        <Typography align="center">
                                            Для вывода средств отправьте его в нашу службу поддержки.
                                        </Typography>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {
                                                setShowMes(false)
                                                setPayoutAddress('')
                                                setPayoutAmount(0)
                                                setPayout(false)
                                            }}
                                        >
                                            Закрыть
                                        </Button>

                                    </>
                                    :
                                    <>
                                        <FormControl fullWidth sx={{ maxWidth: 350 }}>
                                            <InputLabel htmlFor="outlined-adornment-amount">Сумма на вывод</InputLabel>
                                            <OutlinedInput
                                                id="outlined-adornment-amount"
                                                startAdornment={<InputAdornment position="start">₽</InputAdornment>}
                                                label="Сумма на вывод"
                                                value={payoutAmount}
                                                onChange={handleAmountChange}
                                                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                            />
                                        </FormControl>
                                        <FormControl fullWidth sx={{ maxWidth: 350 }}>
                                            <InputLabel htmlFor="outlined-adornment-address">Карта для вывода</InputLabel>
                                            <OutlinedInput
                                                id="outlined-adornment-address"

                                                label="Карта для вывода"
                                                value={payoutAddress}
                                                onChange={handleAddressChange}
                                                inputProps={{ inputMode: 'numeric' }}
                                            />
                                        </FormControl>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            disabled={!isFormValid}
                                            onClick={handlePayoutData}
                                        >
                                            {isLoading ? <CircularProgress size="30px" sx={{ color: "#fff" }} aria-label="Loading…" /> : 'Вывести'}


                                        </Button>
                                    </>
                            }





                        </Box>

                    </DialogContentText>
                </DialogContent>

            </Dialog>

            <Box
                display="flex"
                alignItems="center"
                gap={2}
                justifyContent="flex-end"
            >
                <Box>
                    Баланс: {parseInt(user?.balance, 10)} руб
                </Box>
                <Box>
                    Ожидает вывода: {parseInt(user?.payout, 10)} руб
                </Box>


                {
                    parseInt(user?.balance, 10) > 100 &&
                    <Button
                        variant="contained"
                        color="primary"
                        size={"medium"}
                        onClick={handlerGetPayout}
                    >Вывод средств</Button>
                }

            </Box>

            <Box>
                <Typography variant="h6">Мои заказы</Typography>
            </Box>

            <TableContainer component={Paper}>

                <Table
                    sx={{ tableLayout: 'fixed', minWidth: 300 }}
                >
                    <colgroup>
                        <col style={{ width: '15%' }} />
                        <col style={{ width: '15%' }} />
                        <col style={{ width: '15%' }} />
                        <col style={{ width: '15%' }} />
                        <col style={{ width: '15%' }} />
                        <col style={{ width: '15%' }} />
                    </colgroup>

                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Игра</TableCell>
                            <TableCell>Сервер</TableCell>
                            <TableCell>Монеты</TableCell>
                            <TableCell>Цена</TableCell>
                            <TableCell>Статус</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {
                            data?.user_orders?.map((row) => (
                                <TableRow key={row.id}>
                                    <TableCell>{row.orderId}</TableCell>
                                    <TableCell>{row.game}</TableCell>
                                    <TableCell>{row.server}</TableCell>
                                    <TableCell>{row.coin}</TableCell>
                                    <TableCell>{row.price}</TableCell>
                                    <TableCell>
                                        {
                                            row.status == 'оплаченный' ?
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size={"medium"}
                                                    onClick={() => handlerConfyrm(row.id)}
                                                >Подтвердить</Button>
                                                : row.status
                                        }
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>

                </Table>

            </TableContainer>

            <Box>
                <Typography variant="h6">Монеты на продаже</Typography>
            </Box>

            <TableContainer component={Paper}>

                <Table
                    sx={{ tableLayout: 'fixed', minWidth: 300 }}
                >
                    <colgroup>

                        <col style={{ width: '15%' }} />
                        <col style={{ width: '15%' }} />
                        <col style={{ width: '15%' }} />
                        <col style={{ width: '15%' }} />
                        <col style={{ width: '15%' }} />
                    </colgroup>

                    <TableHead>
                        <TableRow>

                            <TableCell>Игра</TableCell>
                            <TableCell>Сервер</TableCell>
                            <TableCell>Монеты</TableCell>
                            <TableCell>Цена</TableCell>
                            <TableCell>Дата</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {
                            data?.user_coin?.map((row) => (
                                <TableRow key={row.id}>

                                    <TableCell>{row.game}</TableCell>
                                    <TableCell>{row.server}</TableCell>
                                    <TableCell>{row.coin}</TableCell>
                                    <TableCell>{row.amount}</TableCell>
                                    <TableCell>{row.date}</TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>

                </Table>

            </TableContainer>

        </>
    )
}

export default AccountMain;